import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
// import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class GroupGuard implements CanActivate {

  constructor(
    // private msal: MsalService, 
    private router: Router) {}

  canActivate(): boolean {
    // const account = this.msal.instance.getActiveAccount();
    // const groups = (account?.idTokenClaims as any)?.groups ?? [];
    // if (groups.includes('ecdd6c79-56fa-4728-96a9-e6df2ef6e0c4')) {
    //   return true;
    // }
    return true;

    this.router.navigate(['/']);
    return false;
  }
}
